import { OrderProductsTemporaryItem } from "services/interface";
import styled from "@emotion/styled";
import { Affix, Button } from "antd";
import { FC } from "react";
//import { useNavigate } from "react-router-dom";

interface CreateOrderFooterProps {
  loading?: boolean;
  radioSelect: string;
  dataTemporary: OrderProductsTemporaryItem[];
}

const CreateOrderFooter: FC<CreateOrderFooterProps> = ({
  loading,
  dataTemporary,
  radioSelect,
}) => {
  const isDisabled = dataTemporary.length === 0 || radioSelect === "";

  return (
    <Affix offsetBottom={0}>
      <WrapperAll>
        <ButtonWrapper>
          <Button
            danger
            style={{ width: 200, marginRight: "5px" }}
            size="large"
            onClick={() => {
              window.location.reload();
            }}
          >
            รีเซ็ต
          </Button>
          <Button
            htmlType="submit"
            type="primary"
            disabled={isDisabled}
            style={{ width: 200 }}
            size="large"
            loading={loading}
          >
            บันทึก
          </Button>
        </ButtonWrapper>
      </WrapperAll>
    </Affix>
  );
};

export default CreateOrderFooter;

const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
`;
